<template>
  <div>
    <RegisteredPC v-if="isPc" ref="registerForm" :model="model" :schema="schema" @register="handleRegister"></RegisteredPC>
    <RegisteredMobile v-else ref="registerForm" :model="model" :schema="schema" @register="handleRegister" @input="updateModel"></RegisteredMobile>
  </div>
</template>

<script>
import { isUserExisted } from "@/api/login";
import { registerUser, isPhoneExisted } from "@/api/register";
import RegisteredPC from "./RegisteredPC.vue";
import RegisteredMobile from "./RegisteredMobile.vue";

export default {
  components: {
    RegisteredPC,
    RegisteredMobile
  },
  data () {
    return {
      isPc: false,
      toastInstance: null,
      model: {
        username: "",
        phone: "",
        password: "123456",
        checkPassword: "123456"
      },
      schema: {
        fields: [
          {
            type: "input",
            modelKey: "username",
            label: "用户名",
            props: {
              placeholder: "请输入用户名"
            },
            rules: {
              required: true,
              min: 3,
              max: 11,
              usercheck: val => {
                return async resolve => {
                  if (val) {
                    const res = await isUserExisted(val);
                    const { message } = res.data;
                    resolve(!message);
                  } else {
                    resolve(false);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "用户名为必填项",
              usercheck: "用户名已存在"
            }
          },
          {
            type: "input",
            modelKey: "phone",
            label: "手机号",
            props: {
              placeholder: "请填写真实手机号，用于重置密码"
            },
            rules: {
              required: true,
              len: 11,
              phonecheck: val => {
                return async resolve => {
                  if (val) {
                    const res = await isPhoneExisted(val);
                    const { message } = res.data;
                    resolve(!message);
                  } else {
                    resolve(false);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "手机号为必填项",
              phonecheck: "手机号已存在"
            }
          },
          {
            type: "input",
            modelKey: "password",
            label: "密码",
            props: {
              placeholder: "请输入密码",
              type: "password",
              eye: { open: true }
            },
            rules: {
              required: true,
              min: 6,
              max: 16
            },
            trigger: "blur",
            messages: {
              required: "密码为必填项"
            }
          },
          {
            type: "input",
            modelKey: "checkPassword",
            label: "校验",
            props: {
              placeholder: "请再次输入密码",
              type: "password",
              eye: { open: true }
            },
            rules: {
              required: true,
              min: 6,
              max: 16,
              pwdcheck: val => {
                return resolve => {
                  if (val == this.model.password) {
                    resolve(true);
                  } else {
                    resolve(false);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "请再次输入密码",
              pwdcheck: "两次密码输入不一致"
            }
          }
        ]
      }
    };
  },
  methods: {
    createToast (message, type, time, isMask = false) {
      this.toastInstance = this.$createToast({
        txt: message,
        type: type,
        mask: isMask,
        time: time
      });
    },
    toastShow () {
      this.toastInstance.show();
    },
    toasthide () {
      this.toastInstance.hide();
    },
    updateModel(newModel) {
      this.model.username = newModel.username || '';
      this.model.phone = newModel.phone || '';
      this.model.password = newModel.password || '';
      this.model.checkPassword = newModel.checkPassword || '';
    },
    async handleRegister (e) {
      if (e) {
        e.preventDefault();
      }
      try {
        let result = await this.$refs.registerForm.validate();
        if (result) {
          this.createToast("注册中...", "loading", 0, true);
          this.toastShow();
          const res = await registerUser(
            this.model.username,
            this.model.checkPassword,
            this.model.phone
          );
          if (res.status === 200) {
            const { message } = res.data;
            this.createToast(message, "correct", 2000, false);
            setTimeout(() => {
              this.toasthide();
              this.$router.push("/redirect/registered");
            }, 2000);
          } else {
            throw "注册异常";
          }
        } else {
          throw "注册失败";
        }
      } catch (err) {
        this.createToast(err, "error", 2000);
        this.toastShow();
      }
    },
    IsPCVisted() {
      if (window.innerWidth < 768) return false;
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod", "Mobi", "Mobile"];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) !== -1) {
          return false;
        }
      }
      return true;
    }
  },
  created() {
    this.isPc = this.IsPCVisted();
  }
};
</script>

<style>
@import "../assets/stytels/login.css";
</style>
